import React, {useEffect, useState} from "react";
import {Mask, Toast} from "antd-mobile";
import styles from "./style.module.scss";
import close from "@/assets/img/landfi/landgy/icon_del.png";
import {formatLandExpRewardDesc, getAllLandExpRewardData} from "@/view/landGame/utils";
import {hideLoading, showLoading} from "@/components/loading";
import {getRewardService} from "@/api/guland";
import Empty from "@/components/empty";

const GyGetExperienceModal = ({visible, onclose}) => {
  const [refresh, setRefresh] = useState(false)
  const [data, setData] = useState({})

  const getData = async () => {
    try {
      showLoading();
      const res = await getAllLandExpRewardData(1)
      hideLoading();
      setData(res)
    } catch (error) {
      hideLoading();
      Toast.show(typeof error === "string" ? error : error.msg);
    }
  };
  useEffect(() => {
    if (visible) {
      setRefresh(false)
      getData()
    }
  }, [visible])
  const handleOk = async () => {
    try {
      showLoading()
      const res = await getRewardService(1)
      hideLoading()
      const { code, msg, data } = res
      if (code !== '000000') throw msg
      onclose();
      Toast.show('领取成功')
    } catch (e) {
      hideLoading()
      Toast.show(e)
    }
  }
  return (
    <Mask className={styles.gy_experience_mask} visible={visible} destroyOnClose>
      <div className={styles.gy_experience_mask_container}>
        <img
          className={styles.gy_experience_mask_close}
          src={close}
          alt=""
          onClick={() => onclose()}
        />
        <div className={styles.gy_experience_mask_title}>领取经验奖励</div>
        {Object.keys(data).length > 0 ? <>
          <div className={styles.gy_experience_mask_types}>
            {/*宝石*/}
            {data[2] && (
              <div className={styles.gy_experience_mask_type_item} >
                <img src={data[2].prizeImage} alt=""/>
                <div className={styles.gy_experience_mask_type_num}>{data[2]?.prizeNum}</div>
              </div>
            )}
            {/*能量*/}
            {data[4] && (
              <div className={styles.gy_experience_mask_type_item} >
                <img src={data[4].prizeImage} alt=""/>
                <div className={styles.gy_experience_mask_type_num}>{data[4]?.prizeNum}</div>
              </div>
            )}
            {/*土地管理券*/}
            {data[5] && (
              <div className={styles.gy_experience_mask_type_item} >
                <img src={data[5].prizeImage} alt=""/>
                <div className={styles.gy_experience_mask_type_num}>{data[5]?.prizeNum}</div>
              </div>
            )}
            {/*加速卡*/}
            {data[6] && (
              <div className={styles.gy_experience_mask_type_item} >
                <img src={data[6].prizeImage} alt=""/>
                <div className={styles.gy_experience_mask_type_num}>{data[6]?.prizeNum}</div>
              </div>
            )}
            {/*藏品*/}
            {data[3]?.length > 0 && (
              data[3].map((item, index) => (
                  <div className={styles.gy_experience_mask_type_item} key={index}>
                    <img src={item.prizeImage} alt=""/>
                  </div>
                )
              ))}
          </div>
          <div className={styles.gy_experience_mask_total_descp}>
            <span>您所有土地可领取 </span>
            <span className={styles.green_text}>{formatLandExpRewardDesc(data)}</span>
          </div>
          <div className={styles.gy_experience_mask_btn_box}>
            <button className={styles.cancel_btn} onClick={onclose} />
            <button className={styles.ok_btn} onClick={handleOk}/>
          </div>
        </> : <Empty style={{ height: 150}}/>}
      </div>
    </Mask>
  )
}
export default GyGetExperienceModal